export { default } from './ColName';
